export default "__VITE_ASSET__DaZo$NzY__"